// Kaesthetic Travel - Complete Multi-language translations
// Updated with new B2B positioning and experience categories

export const LANGUAGES = [
  { code: 'es', name: 'Español', flag: '🇪🇸', region: 'europe' },
  { code: 'en', name: 'English', flag: '🇬🇧', region: 'europe' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', region: 'europe' },
  { code: 'pt', name: 'Português', flag: '🇵🇹', region: 'europe' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', region: 'europe' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹', region: 'europe' },
  { code: 'el', name: 'Ελληνικά', flag: '🇬🇷', region: 'europe' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', region: 'europe' },
  { code: 'ko', name: '한국어', flag: '🇰🇷', region: 'asia' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', region: 'asia' },
  { code: 'zh', name: '中文', flag: '🇨🇳', region: 'asia' },
];

export const getPositioning = (langCode) => {
  const lang = LANGUAGES.find(l => l.code === langCode);
  if (!lang) return {
    targetRegion: 'Asia',
    focusDestinations: ['South Korea', 'Japan', 'China'],
    companyLocation: 'Seoul, South Korea',
    heroMessage: 'trustedPartnersAsia'
  };
  
  if (lang.region === 'asia') {
    return {
      targetRegion: 'Europe',
      focusDestinations: ['Spain', 'Europe'],
      companyLocation: 'Tarragona, Spain',
      heroMessage: 'trustedPartnersEurope'
    };
  }
  return {
    targetRegion: 'Asia',
    focusDestinations: ['South Korea', 'Japan', 'China'],
    companyLocation: 'Seoul, South Korea',
    heroMessage: 'trustedPartnersAsia'
  };
};

export const translations = {
  // ============== ENGLISH ==============
  en: {
    nav: {
      whatWeDo: 'What We Do',
      experiences: 'Experiences',
      services: 'Services',
      howItWorks: 'Process',
      whyUs: 'Why Us',
      contact: 'Contact'
    },
    hero: {
      overline: 'International B2B Travel Operator',
      trustedPartnersAsia: 'We design and execute high-demand travel experiences through trusted partners in Asia',
      trustedPartnersEurope: 'We design and execute high-demand travel experiences through trusted partners in Europe',
      subtitle: 'We don\'t just connect agencies. We close deals and deliver results.',
      cta1: 'Request Partnership',
      cta2: 'Start Collaboration'
    },
    whatWeDo: {
      overline: 'What We Do',
      title: 'Beyond Connections',
      subtitle: 'We are not a traditional travel agency. We are an international B2B operator that designs, coordinates, and executes travel experiences.',
      point1: {
        title: 'Design Experiences',
        description: 'We create high-demand travel programs tailored to your agency\'s clients.'
      },
      point2: {
        title: 'Connect Partners',
        description: 'We match you with verified local agencies that meet your standards.'
      },
      point3: {
        title: 'Execute Operations',
        description: 'We manage end-to-end coordination and on-ground support.'
      }
    },
    experiences: {
      overline: 'Experience Categories',
      title: 'Specialized Travel Programs',
      subtitle: 'Four distinct verticals designed for high-value international travel.',
      korea: {
        title: 'Beauty & Transformation',
        location: 'South Korea',
        description: 'K-beauty programs, dermatology experiences, personal styling and transformation journeys.',
        tags: ['K-Beauty', 'Aesthetics', 'Transformation']
      },
      japan: {
        title: 'Premium Culture & Gastronomy',
        location: 'Japan',
        description: 'High-end omakase experiences, traditional tea ceremonies, temples, and highly curated premium travel.',
        tags: ['Omakase', 'Culture', 'Premium']
      },
      china: {
        title: 'Business & Cultural',
        location: 'China',
        description: 'Business trips, trade fairs, urban experiences in Shanghai and Shenzhen, historical routes.',
        tags: ['Business', 'Trade', 'Urban']
      },
      spain: {
        title: 'Lifestyle & Social Europe',
        location: 'Spain',
        description: 'Gastronomy, wine, Mediterranean lifestyle, social experiences, premium events and local immersion.',
        tags: ['Gastronomy', 'Lifestyle', 'Social']
      }
    },
    services: {
      overline: 'B2B Services',
      title: 'Full Operational Support',
      service1: {
        title: 'Partner Sourcing',
        description: 'We identify and validate the right local agencies for your needs.'
      },
      service2: {
        title: 'Agency Validation',
        description: 'Rigorous vetting process to ensure quality and reliability.'
      },
      service3: {
        title: 'B2B Negotiation',
        description: 'We handle commercial terms and partnership agreements.'
      },
      service4: {
        title: 'Trip Coordination',
        description: 'Full logistics management from booking to execution.'
      },
      service5: {
        title: 'On-Ground Support',
        description: 'Local assistance throughout the entire travel experience.'
      }
    },
    howItWorks: {
      overline: 'Process',
      title: 'How It Works',
      step1: {
        title: 'Submit Request',
        description: 'Agency submits client requirements and destination preferences.'
      },
      step2: {
        title: 'Design & Match',
        description: 'We design the experience and match with the ideal local partner.'
      },
      step3: {
        title: 'Execute & Deliver',
        description: 'We coordinate operations and execute the trip end-to-end.'
      }
    },
    whyUs: {
      overline: 'Why Kaesthetic',
      title: 'Results, Not Promises',
      benefit1: {
        title: 'Asia–Europe Specialists',
        description: 'Focused exclusively on high-value travel flows between continents.'
      },
      benefit2: {
        title: 'Fast Execution',
        description: 'Response in less than 12 hours. We move at business speed.'
      },
      benefit3: {
        title: 'Verified Network',
        description: 'Every partner is vetted for quality, reliability, and professionalism.'
      },
      benefit4: {
        title: 'End-to-End Control',
        description: 'We manage every detail from first contact to trip completion.'
      }
    },
    cta: {
      title: 'Ready to expand internationally and close more deals?',
      subtitle: 'Partner with us and access high-demand travel markets.',
      button1: 'Contact Us',
      button2: 'Schedule a Call'
    },
    contact: {
      overline: 'Contact',
      title: 'Start Your Partnership',
      subtitle: 'Complete the form. Response within 12 hours.',
      form: {
        name: 'Your Name',
        agency: 'Agency Name',
        country: 'Country',
        email: 'Email',
        message: 'Message',
        messagePlaceholder: 'Tell us about your agency and what markets you want to access...',
        submit: 'Submit Request',
        sending: 'Sending...'
      },
      success: 'Request received. We\'ll contact you within 12 hours.',
      error: 'Error submitting. Please try again.',
      phone: {
        europe: 'Europe',
        asia: 'Asia'
      }
    },
    footer: {
      tagline: 'International B2B Travel Operator',
      rights: 'All rights reserved.'
    },
    specialization: {
      overline: 'Our Specializations',
      title: 'Destination Expertise',
      subtitle: 'Deep local knowledge in key markets between Europe and Asia.',
      korea: {
        title: 'South Korea',
        description: 'K-beauty, wellness clinics, cultural experiences and aesthetic tourism in Seoul and beyond.'
      },
      japan: {
        title: 'Japan',
        description: 'Premium cultural immersion, Michelin-starred dining, traditional ryokan and curated luxury travel.'
      },
      spain: {
        title: 'Spain',
        description: 'Mediterranean gastronomy, wine routes, Modernisme architecture and premium lifestyle experiences.'
      }
    }
  },
  es: {
    nav: {
      whatWeDo: 'Qué Hacemos',
      experiences: 'Experiencias',
      services: 'Servicios',
      howItWorks: 'Proceso',
      whyUs: 'Por Qué Nosotros',
      contact: 'Contacto'
    },
    hero: {
      overline: 'Operador B2B de Viajes Internacional',
      trustedPartnersAsia: 'Diseñamos y ejecutamos experiencias de viaje de alta demanda con socios de confianza en Asia',
      trustedPartnersEurope: 'Diseñamos y ejecutamos experiencias de viaje de alta demanda con socios de confianza en Europa',
      subtitle: 'No solo conectamos agencias. Cerramos acuerdos y entregamos resultados.',
      cta1: 'Solicitar Partnership',
      cta2: 'Iniciar Colaboración'
    },
    whatWeDo: {
      overline: 'Qué Hacemos',
      title: 'Más Allá de las Conexiones',
      subtitle: 'No somos una agencia de viajes tradicional. Somos un operador B2B internacional que diseña, coordina y ejecuta experiencias de viaje.',
      point1: {
        title: 'Diseñamos Experiencias',
        description: 'Creamos programas de viaje de alta demanda adaptados a los clientes de tu agencia.'
      },
      point2: {
        title: 'Conectamos Socios',
        description: 'Te emparejamos con agencias locales verificadas que cumplen tus estándares.'
      },
      point3: {
        title: 'Ejecutamos Operaciones',
        description: 'Gestionamos la coordinación completa y soporte en destino.'
      }
    },
    experiences: {
      overline: 'Categorías de Experiencia',
      title: 'Programas de Viaje Especializados',
      subtitle: 'Cuatro verticales diseñadas para viajes internacionales de alto valor.',
      korea: {
        title: 'Belleza y Transformación',
        location: 'Corea del Sur',
        description: 'Programas K-beauty, experiencias dermatológicas, estilismo personal y viajes de transformación.',
        tags: ['K-Beauty', 'Estética', 'Transformación']
      },
      japan: {
        title: 'Cultura y Gastronomía Premium',
        location: 'Japón',
        description: 'Experiencias omakase de alto nivel, ceremonias del té tradicionales, templos y viajes premium muy curados.',
        tags: ['Omakase', 'Cultura', 'Premium']
      },
      china: {
        title: 'Negocios y Cultura',
        location: 'China',
        description: 'Viajes de negocios, ferias comerciales, experiencias urbanas en Shanghai y Shenzhen, rutas históricas.',
        tags: ['Negocios', 'Comercio', 'Urbano']
      },
      spain: {
        title: 'Lifestyle y Social Europa',
        location: 'España',
        description: 'Gastronomía, vino, estilo de vida mediterráneo, experiencias sociales, eventos premium e inmersión local.',
        tags: ['Gastronomía', 'Lifestyle', 'Social']
      }
    },
    services: {
      overline: 'Servicios B2B',
      title: 'Soporte Operacional Completo',
      service1: {
        title: 'Búsqueda de Socios',
        description: 'Identificamos y validamos las agencias locales adecuadas para tus necesidades.'
      },
      service2: {
        title: 'Validación de Agencias',
        description: 'Proceso de verificación riguroso para asegurar calidad y fiabilidad.'
      },
      service3: {
        title: 'Negociación B2B',
        description: 'Gestionamos términos comerciales y acuerdos de partnership.'
      },
      service4: {
        title: 'Coordinación de Viajes',
        description: 'Gestión logística completa desde la reserva hasta la ejecución.'
      },
      service5: {
        title: 'Soporte en Destino',
        description: 'Asistencia local durante toda la experiencia de viaje.'
      }
    },
    howItWorks: {
      overline: 'Proceso',
      title: 'Cómo Funciona',
      step1: {
        title: 'Envía Solicitud',
        description: 'La agencia envía requisitos del cliente y preferencias de destino.'
      },
      step2: {
        title: 'Diseño y Match',
        description: 'Diseñamos la experiencia y conectamos con el socio local ideal.'
      },
      step3: {
        title: 'Ejecutamos y Entregamos',
        description: 'Coordinamos operaciones y ejecutamos el viaje de principio a fin.'
      }
    },
    whyUs: {
      overline: 'Por Qué Kaesthetic',
      title: 'Resultados, No Promesas',
      benefit1: {
        title: 'Especialistas Asia–Europa',
        description: 'Enfocados exclusivamente en flujos de viaje de alto valor entre continentes.'
      },
      benefit2: {
        title: 'Ejecución Rápida',
        description: 'Respuesta en menos de 12 horas. Nos movemos a velocidad de negocio.'
      },
      benefit3: {
        title: 'Red Verificada',
        description: 'Cada socio está validado por calidad, fiabilidad y profesionalismo.'
      },
      benefit4: {
        title: 'Control Total',
        description: 'Gestionamos cada detalle desde el primer contacto hasta completar el viaje.'
      }
    },
    cta: {
      title: '¿Listo para expandirte internacionalmente y cerrar más acuerdos?',
      subtitle: 'Asóciate con nosotros y accede a mercados de viaje de alta demanda.',
      button1: 'Contactar',
      button2: 'Agendar Llamada'
    },
    contact: {
      overline: 'Contacto',
      title: 'Inicia tu Partnership',
      subtitle: 'Completa el formulario. Respuesta en 12 horas.',
      form: {
        name: 'Tu Nombre',
        agency: 'Nombre de Agencia',
        country: 'País',
        email: 'Email',
        message: 'Mensaje',
        messagePlaceholder: 'Cuéntanos sobre tu agencia y qué mercados quieres acceder...',
        submit: 'Enviar Solicitud',
        sending: 'Enviando...'
      },
      success: 'Solicitud recibida. Te contactaremos en 12 horas.',
      error: 'Error al enviar. Por favor intenta de nuevo.',
      phone: {
        europe: 'Europa',
        asia: 'Asia'
      }
    },
    footer: {
      tagline: 'Operador B2B de Viajes Internacional',
      rights: 'Todos los derechos reservados.'
    },
    specialization: {
      overline: 'Nuestras Especializaciones',
      title: 'Experiencia en Destinos',
      subtitle: 'Conocimiento local profundo en mercados clave entre Europa y Asia.',
      korea: {
        title: 'Corea del Sur',
        description: 'K-beauty, clínicas de bienestar, experiencias culturales y turismo estético en Seúl y más.'
      },
      japan: {
        title: 'Japón',
        description: 'Inmersión cultural premium, gastronomía con estrellas Michelin, ryokan tradicional y viajes de lujo.'
      },
      spain: {
        title: 'España',
        description: 'Gastronomía mediterránea, rutas de vino, arquitectura modernista y experiencias de lifestyle premium.'
      }
    }
  },

  // ============== KOREAN ==============
  ko: {
    nav: {
      whatWeDo: '서비스 소개',
      experiences: '경험',
      services: '서비스',
      howItWorks: '프로세스',
      whyUs: '왜 저희인가',
      contact: '문의'
    },
    hero: {
      overline: '국제 B2B 여행 운영사',
      trustedPartnersAsia: '아시아의 신뢰할 수 있는 파트너를 통해 고수요 여행 경험을 설계하고 실행합니다',
      trustedPartnersEurope: '유럽의 신뢰할 수 있는 파트너를 통해 고수요 여행 경험을 설계하고 실행합니다',
      subtitle: '단순한 에이전시 연결이 아닙니다. 계약을 성사시키고 결과를 제공합니다.',
      cta1: '파트너십 요청',
      cta2: '협력 시작'
    },
    whatWeDo: {
      overline: '서비스 소개',
      title: '연결 그 이상',
      subtitle: '저희는 전통적인 여행사가 아닙니다. 여행 경험을 설계, 조정, 실행하는 국제 B2B 운영사입니다.',
      point1: {
        title: '경험 설계',
        description: '귀사 고객을 위한 맞춤형 고수요 여행 프로그램을 만듭니다.'
      },
      point2: {
        title: '파트너 연결',
        description: '귀사의 기준에 맞는 검증된 현지 에이전시와 매칭합니다.'
      },
      point3: {
        title: '운영 실행',
        description: '전체 조정 및 현지 지원을 관리합니다.'
      }
    },
    experiences: {
      overline: '경험 카테고리',
      title: '전문 여행 프로그램',
      subtitle: '고가치 국제 여행을 위한 4가지 전문 분야.',
      korea: {
        title: '뷰티 & 트랜스포메이션',
        location: '한국',
        description: 'K-뷰티 프로그램, 피부과 경험, 퍼스널 스타일링 및 변신 여정.',
        tags: ['K-뷰티', '에스테틱', '변신']
      },
      japan: {
        title: '프리미엄 문화 & 미식',
        location: '일본',
        description: '하이엔드 오마카세 경험, 전통 다도, 사찰, 고급 큐레이션 여행.',
        tags: ['오마카세', '문화', '프리미엄']
      },
      china: {
        title: '비즈니스 & 문화',
        location: '중국',
        description: '비즈니스 출장, 무역 박람회, 상하이와 선전의 도시 경험, 역사 루트.',
        tags: ['비즈니스', '무역', '도시']
      },
      spain: {
        title: '라이프스타일 & 소셜 유럽',
        location: '스페인',
        description: '미식, 와인, 지중해 라이프스타일, 소셜 경험, 프리미엄 이벤트 및 현지 몰입.',
        tags: ['미식', '라이프스타일', '소셜']
      }
    },
    services: {
      overline: 'B2B 서비스',
      title: '전체 운영 지원',
      service1: {
        title: '파트너 발굴',
        description: '귀사의 필요에 맞는 현지 에이전시를 식별하고 검증합니다.'
      },
      service2: {
        title: '에이전시 검증',
        description: '품질과 신뢰성을 보장하는 엄격한 검증 프로세스.'
      },
      service3: {
        title: 'B2B 협상',
        description: '상업 조건 및 파트너십 계약을 처리합니다.'
      },
      service4: {
        title: '여행 조정',
        description: '예약부터 실행까지 전체 물류 관리.'
      },
      service5: {
        title: '현지 지원',
        description: '전체 여행 경험 동안 현지 지원.'
      }
    },
    howItWorks: {
      overline: '프로세스',
      title: '이용 방법',
      step1: {
        title: '요청 제출',
        description: '에이전시가 고객 요구사항과 목적지 선호도를 제출합니다.'
      },
      step2: {
        title: '설계 & 매칭',
        description: '경험을 설계하고 이상적인 현지 파트너와 매칭합니다.'
      },
      step3: {
        title: '실행 & 제공',
        description: '운영을 조정하고 처음부터 끝까지 여행을 실행합니다.'
      }
    },
    whyUs: {
      overline: '왜 Kaesthetic인가',
      title: '약속이 아닌 결과',
      benefit1: {
        title: '아시아-유럽 전문가',
        description: '대륙 간 고가치 여행 흐름에만 집중합니다.'
      },
      benefit2: {
        title: '빠른 실행',
        description: '12시간 이내 응답. 비즈니스 속도로 움직입니다.'
      },
      benefit3: {
        title: '검증된 네트워크',
        description: '모든 파트너는 품질, 신뢰성, 전문성으로 검증됩니다.'
      },
      benefit4: {
        title: '전체 통제',
        description: '첫 연락부터 여행 완료까지 모든 세부사항을 관리합니다.'
      }
    },
    cta: {
      title: '국제적으로 확장하고 더 많은 계약을 성사시킬 준비가 되셨나요?',
      subtitle: '저희와 파트너가 되어 고수요 여행 시장에 접근하세요.',
      button1: '문의하기',
      button2: '통화 예약'
    },
    contact: {
      overline: '문의',
      title: '파트너십 시작',
      subtitle: '양식을 작성하세요. 12시간 내 응답.',
      form: {
        name: '이름',
        agency: '에이전시명',
        country: '국가',
        email: '이메일',
        message: '메시지',
        messagePlaceholder: '귀사의 에이전시와 접근하고자 하는 시장에 대해 알려주세요...',
        submit: '요청 제출',
        sending: '전송 중...'
      },
      success: '요청이 접수되었습니다. 12시간 내 연락드리겠습니다.',
      error: '전송 오류. 다시 시도해 주세요.',
      phone: {
        europe: '유럽',
        asia: '아시아'
      }
    },
    footer: {
      tagline: '국제 B2B 여행 운영사',
      rights: '모든 권리 보유.'
    },
    specialization: {
      overline: '전문 분야',
      title: '목적지 전문성',
      subtitle: '유럽과 아시아의 핵심 시장에 대한 깊은 현지 지식.',
      korea: {
        title: '대한민국',
        description: '서울과 그 주변의 K-뷰티, 웰니스 클리닉, 문화 체험 및 에스테틱 관광.'
      },
      japan: {
        title: '일본',
        description: '프리미엄 문화 몰입, 미슐랭 스타 레스토랑, 전통 료칸 및 맞춤 럭셔리 여행.'
      },
      spain: {
        title: '스페인',
        description: '지중해 미식, 와인 루트, 모더니즘 건축 및 프리미엄 라이프스타일 경험.'
      }
    }
  },

  // ============== JAPANESE ==============
  ja: {
    nav: {
      whatWeDo: 'サービス',
      experiences: '体験',
      services: 'サービス',
      howItWorks: 'プロセス',
      whyUs: '選ばれる理由',
      contact: 'お問い合わせ'
    },
    hero: {
      overline: '国際B2B旅行オペレーター',
      trustedPartnersAsia: 'アジアの信頼できるパートナーを通じて、需要の高い旅行体験を設計・実行します',
      trustedPartnersEurope: 'ヨーロッパの信頼できるパートナーを通じて、需要の高い旅行体験を設計・実行します',
      subtitle: '代理店を繋ぐだけではありません。契約を成立させ、結果を届けます。',
      cta1: 'パートナーシップ申請',
      cta2: 'コラボレーション開始'
    },
    whatWeDo: {
      overline: 'サービス',
      title: '接続を超えて',
      subtitle: '私たちは従来の旅行代理店ではありません。旅行体験を設計、調整、実行する国際B2Bオペレーターです。',
      point1: {
        title: '体験を設計',
        description: '貴社のクライアント向けにカスタマイズされた需要の高い旅行プログラムを作成します。'
      },
      point2: {
        title: 'パートナーを接続',
        description: '貴社の基準を満たす検証済みの地元代理店とマッチングします。'
      },
      point3: {
        title: '運営を実行',
        description: 'エンドツーエンドの調整と現地サポートを管理します。'
      }
    },
    experiences: {
      overline: '体験カテゴリー',
      title: '専門旅行プログラム',
      subtitle: '高価値な国際旅行のための4つの専門分野。',
      korea: {
        title: 'ビューティー＆トランスフォーメーション',
        location: '韓国',
        description: 'K-ビューティープログラム、皮膚科体験、パーソナルスタイリング、変身の旅。',
        tags: ['K-ビューティー', 'エステティック', '変身']
      },
      japan: {
        title: 'プレミアム文化＆美食',
        location: '日本',
        description: 'ハイエンドおまかせ体験、伝統的な茶道、寺院、厳選されたプレミアム旅行。',
        tags: ['おまかせ', '文化', 'プレミアム']
      },
      china: {
        title: 'ビジネス＆文化',
        location: '中国',
        description: 'ビジネス出張、見本市、上海・深センの都市体験、歴史ルート。',
        tags: ['ビジネス', '貿易', '都市']
      },
      spain: {
        title: 'ライフスタイル＆ソーシャルヨーロッパ',
        location: 'スペイン',
        description: '美食、ワイン、地中海ライフスタイル、ソーシャル体験、プレミアムイベント、ローカル体験。',
        tags: ['美食', 'ライフスタイル', 'ソーシャル']
      }
    },
    services: {
      overline: 'B2Bサービス',
      title: 'フル運営サポート',
      service1: {
        title: 'パートナー発掘',
        description: '貴社のニーズに合った地元代理店を特定し検証します。'
      },
      service2: {
        title: '代理店検証',
        description: '品質と信頼性を確保する厳格な審査プロセス。'
      },
      service3: {
        title: 'B2B交渉',
        description: '商業条件とパートナーシップ契約を処理します。'
      },
      service4: {
        title: '旅行調整',
        description: '予約から実行までの完全な物流管理。'
      },
      service5: {
        title: '現地サポート',
        description: '旅行体験全体を通じた現地アシスタンス。'
      }
    },
    howItWorks: {
      overline: 'プロセス',
      title: 'ご利用方法',
      step1: {
        title: 'リクエスト送信',
        description: '代理店がクライアント要件と目的地の好みを送信します。'
      },
      step2: {
        title: '設計＆マッチング',
        description: '体験を設計し、理想的な地元パートナーとマッチングします。'
      },
      step3: {
        title: '実行＆提供',
        description: '運営を調整し、旅行をエンドツーエンドで実行します。'
      }
    },
    whyUs: {
      overline: 'Kaesthetic Travelを選ぶ理由',
      title: '約束ではなく結果',
      benefit1: {
        title: 'アジア−ヨーロッパ専門家',
        description: '大陸間の高価値旅行フローに特化しています。'
      },
      benefit2: {
        title: '迅速な実行',
        description: '12時間以内の回答。ビジネススピードで動きます。'
      },
      benefit3: {
        title: '検証済みネットワーク',
        description: 'すべてのパートナーは品質、信頼性、プロフェッショナリズムで検証されています。'
      },
      benefit4: {
        title: 'エンドツーエンド管理',
        description: '最初の連絡から旅行完了まですべての詳細を管理します。'
      }
    },
    cta: {
      title: '国際的に拡大し、より多くの契約を成立させる準備はできていますか？',
      subtitle: '私たちとパートナーになり、需要の高い旅行市場にアクセスしてください。',
      button1: 'お問い合わせ',
      button2: '通話を予約'
    },
    contact: {
      overline: 'お問い合わせ',
      title: 'パートナーシップを始める',
      subtitle: 'フォームに記入してください。12時間以内に回答します。',
      form: {
        name: 'お名前',
        agency: '代理店名',
        country: '国',
        email: 'メール',
        message: 'メッセージ',
        messagePlaceholder: '貴社の代理店とアクセスしたい市場についてお聞かせください...',
        submit: 'リクエスト送信',
        sending: '送信中...'
      },
      success: 'リクエストを受け付けました。12時間以内にご連絡します。',
      error: '送信エラー。もう一度お試しください。',
      phone: {
        europe: 'ヨーロッパ',
        asia: 'アジア'
      }
    },
    footer: {
      tagline: '国際B2B旅行オペレーター',
      rights: '全著作権所有。'
    },
    specialization: {
      overline: '専門分野',
      title: '目的地の専門性',
      subtitle: 'ヨーロッパとアジアの主要市場に関する深い現地知識。',
      korea: {
        title: '韓国',
        description: 'ソウルとその周辺でのKビューティー、ウェルネスクリニック、文化体験、審美的観光。'
      },
      japan: {
        title: '日本',
        description: 'プレミアム文化体験、ミシュランスター料理、伝統的な旅館、厳選ラグジュアリー旅行。'
      },
      spain: {
        title: 'スペイン',
        description: '地中海料理、ワインルート、モデルニスメ建築、プレミアムライフスタイル体験。'
      }
    }
  },

  // ============== CHINESE ==============
  zh: {
    nav: {
      whatWeDo: '服务介绍',
      experiences: '体验',
      services: '服务',
      howItWorks: '流程',
      whyUs: '为什么选择我们',
      contact: '联系'
    },
    hero: {
      overline: '国际B2B旅游运营商',
      trustedPartnersAsia: '我们通过亚洲值得信赖的合作伙伴设计和执行高需求旅行体验',
      trustedPartnersEurope: '我们通过欧洲值得信赖的合作伙伴设计和执行高需求旅行体验',
      subtitle: '我们不仅仅是连接代理商。我们达成交易并交付成果。',
      cta1: '申请合作',
      cta2: '开始协作'
    },
    whatWeDo: {
      overline: '服务介绍',
      title: '超越连接',
      subtitle: '我们不是传统的旅行社。我们是设计、协调和执行旅行体验的国际B2B运营商。',
      point1: {
        title: '设计体验',
        description: '我们为贵公司客户创建定制的高需求旅行项目。'
      },
      point2: {
        title: '连接合作伙伴',
        description: '我们将您与符合您标准的经过验证的当地代理商匹配。'
      },
      point3: {
        title: '执行运营',
        description: '我们管理端到端协调和现场支持。'
      }
    },
    experiences: {
      overline: '体验类别',
      title: '专业旅行项目',
      subtitle: '为高价值国际旅行设计的四个专业领域。',
      korea: {
        title: '美容与蜕变',
        location: '韩国',
        description: 'K-美容项目、皮肤科体验、个人造型和蜕变之旅。',
        tags: ['K-美容', '美学', '蜕变']
      },
      japan: {
        title: '高端文化与美食',
        location: '日本',
        description: '高端omakase体验、传统茶道、寺庙和精心策划的高端旅行。',
        tags: ['Omakase', '文化', '高端']
      },
      china: {
        title: '商务与文化',
        location: '中国',
        description: '商务出差、贸易展览、上海和深圳的城市体验、历史路线。',
        tags: ['商务', '贸易', '城市']
      },
      spain: {
        title: '生活方式与社交欧洲',
        location: '西班牙',
        description: '美食、葡萄酒、地中海生活方式、社交体验、高端活动和本地沉浸。',
        tags: ['美食', '生活方式', '社交']
      }
    },
    services: {
      overline: 'B2B服务',
      title: '全方位运营支持',
      service1: {
        title: '合作伙伴发掘',
        description: '我们识别和验证符合您需求的当地代理商。'
      },
      service2: {
        title: '代理商验证',
        description: '严格的审核流程以确保质量和可靠性。'
      },
      service3: {
        title: 'B2B谈判',
        description: '我们处理商业条款和合作协议。'
      },
      service4: {
        title: '行程协调',
        description: '从预订到执行的完整物流管理。'
      },
      service5: {
        title: '现场支持',
        description: '整个旅行体验期间的当地协助。'
      }
    },
    howItWorks: {
      overline: '流程',
      title: '如何运作',
      step1: {
        title: '提交请求',
        description: '代理商提交客户需求和目的地偏好。'
      },
      step2: {
        title: '设计与匹配',
        description: '我们设计体验并与理想的当地合作伙伴匹配。'
      },
      step3: {
        title: '执行与交付',
        description: '我们协调运营并端到端执行行程。'
      }
    },
    whyUs: {
      overline: '为什么选择Kaesthetic Travel',
      title: '结果，而非承诺',
      benefit1: {
        title: '亚洲-欧洲专家',
        description: '专注于大陆间高价值旅行流。'
      },
      benefit2: {
        title: '快速执行',
        description: '12小时内响应。我们以商业速度运作。'
      },
      benefit3: {
        title: '经过验证的网络',
        description: '每个合作伙伴都经过质量、可靠性和专业性验证。'
      },
      benefit4: {
        title: '端到端控制',
        description: '我们管理从首次联系到行程完成的每个细节。'
      }
    },
    cta: {
      title: '准备好在国际上扩张并达成更多交易了吗？',
      subtitle: '与我们合作，进入高需求旅游市场。',
      button1: '联系我们',
      button2: '预约通话'
    },
    contact: {
      overline: '联系',
      title: '开始您的合作',
      subtitle: '填写表格。12小时内回复。',
      form: {
        name: '您的姓名',
        agency: '代理商名称',
        country: '国家',
        email: '邮箱',
        message: '留言',
        messagePlaceholder: '告诉我们您的代理商以及您想要进入的市场...',
        submit: '提交请求',
        sending: '发送中...'
      },
      success: '请求已收到。我们将在12小时内联系您。',
      error: '发送错误。请重试。',
      phone: {
        europe: '欧洲',
        asia: '亚洲'
      }
    },
    footer: {
      tagline: '国际B2B旅游运营商',
      rights: '版权所有。'
    },
    specialization: {
      overline: '我们的专业领域',
      title: '目的地专业知识',
      subtitle: '对欧洲与亚洲主要市场的深度本地知识。',
      korea: {
        title: '韩国',
        description: '首尔及周边的韩流美容、健康诊所、文化体验和美学旅游。'
      },
      japan: {
        title: '日本',
        description: '高端文化沉浸、米其林星级餐厅、传统旅馆和精选奢华旅行。'
      },
      spain: {
        title: '西班牙',
        description: '地中海美食、葡萄酒之路、现代主义建筑和高端生活方式体验。'
      }
    }
  },

  // ============== FRENCH ==============
  fr: {
    nav: {
      whatWeDo: 'Ce Que Nous Faisons',
      experiences: 'Expériences',
      services: 'Services',
      howItWorks: 'Processus',
      whyUs: 'Pourquoi Nous',
      contact: 'Contact'
    },
    hero: {
      overline: 'Opérateur B2B de Voyage International',
      trustedPartnersAsia: 'Nous concevons et exécutons des expériences de voyage à forte demande via des partenaires de confiance en Asie',
      trustedPartnersEurope: 'Nous concevons et exécutons des expériences de voyage à forte demande via des partenaires de confiance en Europe',
      subtitle: 'Nous ne connectons pas seulement des agences. Nous concluons des accords et livrons des résultats.',
      cta1: 'Demander un Partenariat',
      cta2: 'Démarrer la Collaboration'
    },
    whatWeDo: {
      overline: 'Ce Que Nous Faisons',
      title: 'Au-Delà des Connexions',
      subtitle: 'Nous ne sommes pas une agence de voyage traditionnelle. Nous sommes un opérateur B2B international qui conçoit, coordonne et exécute des expériences de voyage.',
      point1: {
        title: 'Conception d\'Expériences',
        description: 'Nous créons des programmes de voyage à forte demande adaptés aux clients de votre agence.'
      },
      point2: {
        title: 'Connexion de Partenaires',
        description: 'Nous vous mettons en relation avec des agences locales vérifiées qui répondent à vos standards.'
      },
      point3: {
        title: 'Exécution des Opérations',
        description: 'Nous gérons la coordination complète et le support sur place.'
      }
    },
    experiences: {
      overline: 'Catégories d\'Expérience',
      title: 'Programmes de Voyage Spécialisés',
      subtitle: 'Quatre verticales conçues pour les voyages internationaux de haute valeur.',
      korea: {
        title: 'Beauté & Transformation',
        location: 'Corée du Sud',
        description: 'Programmes K-beauty, expériences dermatologiques, stylisme personnel et voyages de transformation.',
        tags: ['K-Beauty', 'Esthétique', 'Transformation']
      },
      japan: {
        title: 'Culture & Gastronomie Premium',
        location: 'Japon',
        description: 'Expériences omakase haut de gamme, cérémonies du thé traditionnelles, temples et voyages premium très curatés.',
        tags: ['Omakase', 'Culture', 'Premium']
      },
      china: {
        title: 'Business & Culture',
        location: 'Chine',
        description: 'Voyages d\'affaires, salons professionnels, expériences urbaines à Shanghai et Shenzhen, routes historiques.',
        tags: ['Business', 'Commerce', 'Urbain']
      },
      spain: {
        title: 'Lifestyle & Social Europe',
        location: 'Espagne',
        description: 'Gastronomie, vin, style de vie méditerranéen, expériences sociales, événements premium et immersion locale.',
        tags: ['Gastronomie', 'Lifestyle', 'Social']
      }
    },
    services: {
      overline: 'Services B2B',
      title: 'Support Opérationnel Complet',
      service1: {
        title: 'Recherche de Partenaires',
        description: 'Nous identifions et validons les bonnes agences locales pour vos besoins.'
      },
      service2: {
        title: 'Validation d\'Agences',
        description: 'Processus de vérification rigoureux pour assurer qualité et fiabilité.'
      },
      service3: {
        title: 'Négociation B2B',
        description: 'Nous gérons les termes commerciaux et les accords de partenariat.'
      },
      service4: {
        title: 'Coordination de Voyages',
        description: 'Gestion logistique complète de la réservation à l\'exécution.'
      },
      service5: {
        title: 'Support sur Place',
        description: 'Assistance locale tout au long de l\'expérience de voyage.'
      }
    },
    howItWorks: {
      overline: 'Processus',
      title: 'Comment Ça Marche',
      step1: {
        title: 'Soumettez Votre Demande',
        description: 'L\'agence soumet les exigences du client et les préférences de destination.'
      },
      step2: {
        title: 'Conception & Matching',
        description: 'Nous concevons l\'expérience et trouvons le partenaire local idéal.'
      },
      step3: {
        title: 'Exécution & Livraison',
        description: 'Nous coordonnons les opérations et exécutons le voyage de bout en bout.'
      }
    },
    whyUs: {
      overline: 'Pourquoi Kaesthetic',
      title: 'Des Résultats, Pas des Promesses',
      benefit1: {
        title: 'Spécialistes Asie–Europe',
        description: 'Focalisés exclusivement sur les flux de voyage de haute valeur entre continents.'
      },
      benefit2: {
        title: 'Exécution Rapide',
        description: 'Réponse en moins de 12 heures. Nous bougeons à la vitesse des affaires.'
      },
      benefit3: {
        title: 'Réseau Vérifié',
        description: 'Chaque partenaire est validé pour sa qualité, fiabilité et professionnalisme.'
      },
      benefit4: {
        title: 'Contrôle Total',
        description: 'Nous gérons chaque détail du premier contact à la fin du voyage.'
      }
    },
    cta: {
      title: 'Prêt à vous développer à l\'international et à conclure plus d\'affaires?',
      subtitle: 'Associez-vous à nous et accédez aux marchés de voyage à forte demande.',
      button1: 'Contactez-nous',
      button2: 'Planifier un Appel'
    },
    contact: {
      overline: 'Contact',
      title: 'Démarrez Votre Partenariat',
      subtitle: 'Remplissez le formulaire. Réponse sous 12 heures.',
      form: {
        name: 'Votre Nom',
        agency: 'Nom de l\'Agence',
        country: 'Pays',
        email: 'Email',
        message: 'Message',
        messagePlaceholder: 'Parlez-nous de votre agence et des marchés que vous souhaitez accéder...',
        submit: 'Envoyer la Demande',
        sending: 'Envoi en cours...'
      },
      success: 'Demande reçue. Nous vous contacterons sous 12 heures.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
      phone: {
        europe: 'Europe',
        asia: 'Asie'
      }
    },
    footer: {
      tagline: 'Opérateur B2B de Voyage International',
      rights: 'Tous droits réservés.'
    },
    specialization: {
      overline: 'Nos Spécialisations',
      title: 'Expertise des Destinations',
      subtitle: 'Connaissance locale approfondie des marchés clés entre l\'Europe et l\'Asie.',
      korea: {
        title: 'Corée du Sud',
        description: 'K-beauty, cliniques de bien-être, expériences culturelles et tourisme esthétique à Séoul et au-delà.'
      },
      japan: {
        title: 'Japon',
        description: 'Immersion culturelle premium, gastronomie étoilée Michelin, ryokan traditionnel et voyages de luxe.'
      },
      spain: {
        title: 'Espagne',
        description: 'Gastronomie méditerranéenne, routes des vins, architecture moderniste et expériences lifestyle premium.'
      }
    }
  },

  // ============== PORTUGUESE ==============
  pt: {
    nav: {
      whatWeDo: 'O Que Fazemos',
      experiences: 'Experiências',
      services: 'Serviços',
      howItWorks: 'Processo',
      whyUs: 'Por Que Nós',
      contact: 'Contato'
    },
    hero: {
      overline: 'Operador B2B de Viagens Internacional',
      trustedPartnersAsia: 'Projetamos e executamos experiências de viagem de alta demanda com parceiros confiáveis na Ásia',
      trustedPartnersEurope: 'Projetamos e executamos experiências de viagem de alta demanda com parceiros confiáveis na Europa',
      subtitle: 'Não apenas conectamos agências. Fechamos negócios e entregamos resultados.',
      cta1: 'Solicitar Parceria',
      cta2: 'Iniciar Colaboração'
    },
    whatWeDo: {
      overline: 'O Que Fazemos',
      title: 'Além das Conexões',
      subtitle: 'Não somos uma agência de viagens tradicional. Somos um operador B2B internacional que projeta, coordena e executa experiências de viagem.',
      point1: {
        title: 'Projetamos Experiências',
        description: 'Criamos programas de viagem de alta demanda adaptados aos clientes da sua agência.'
      },
      point2: {
        title: 'Conectamos Parceiros',
        description: 'Conectamos você com agências locais verificadas que atendem seus padrões.'
      },
      point3: {
        title: 'Executamos Operações',
        description: 'Gerenciamos coordenação completa e suporte no local.'
      }
    },
    experiences: {
      overline: 'Categorias de Experiência',
      title: 'Programas de Viagem Especializados',
      subtitle: 'Quatro verticais projetadas para viagens internacionais de alto valor.',
      korea: {
        title: 'Beleza e Transformação',
        location: 'Coreia do Sul',
        description: 'Programas K-beauty, experiências dermatológicas, estilismo pessoal e jornadas de transformação.',
        tags: ['K-Beauty', 'Estética', 'Transformação']
      },
      japan: {
        title: 'Cultura e Gastronomia Premium',
        location: 'Japão',
        description: 'Experiências omakase de alto nível, cerimônias do chá tradicionais, templos e viagens premium muito curadas.',
        tags: ['Omakase', 'Cultura', 'Premium']
      },
      china: {
        title: 'Negócios e Cultura',
        location: 'China',
        description: 'Viagens de negócios, feiras comerciais, experiências urbanas em Shanghai e Shenzhen, rotas históricas.',
        tags: ['Negócios', 'Comércio', 'Urbano']
      },
      spain: {
        title: 'Lifestyle e Social Europa',
        location: 'Espanha',
        description: 'Gastronomia, vinho, estilo de vida mediterrâneo, experiências sociais, eventos premium e imersão local.',
        tags: ['Gastronomia', 'Lifestyle', 'Social']
      }
    },
    services: {
      overline: 'Serviços B2B',
      title: 'Suporte Operacional Completo',
      service1: {
        title: 'Busca de Parceiros',
        description: 'Identificamos e validamos as agências locais certas para suas necessidades.'
      },
      service2: {
        title: 'Validação de Agências',
        description: 'Processo de verificação rigoroso para garantir qualidade e confiabilidade.'
      },
      service3: {
        title: 'Negociação B2B',
        description: 'Cuidamos de termos comerciais e acordos de parceria.'
      },
      service4: {
        title: 'Coordenação de Viagens',
        description: 'Gestão logística completa da reserva à execução.'
      },
      service5: {
        title: 'Suporte no Local',
        description: 'Assistência local durante toda a experiência de viagem.'
      }
    },
    howItWorks: {
      overline: 'Processo',
      title: 'Como Funciona',
      step1: {
        title: 'Envie Sua Solicitação',
        description: 'A agência envia requisitos do cliente e preferências de destino.'
      },
      step2: {
        title: 'Design e Match',
        description: 'Projetamos a experiência e conectamos com o parceiro local ideal.'
      },
      step3: {
        title: 'Execução e Entrega',
        description: 'Coordenamos operações e executamos a viagem de ponta a ponta.'
      }
    },
    whyUs: {
      overline: 'Por Que Kaesthetic',
      title: 'Resultados, Não Promessas',
      benefit1: {
        title: 'Especialistas Ásia–Europa',
        description: 'Focados exclusivamente em fluxos de viagem de alto valor entre continentes.'
      },
      benefit2: {
        title: 'Execução Rápida',
        description: 'Resposta em menos de 12 horas. Nos movemos na velocidade dos negócios.'
      },
      benefit3: {
        title: 'Rede Verificada',
        description: 'Cada parceiro é validado por qualidade, confiabilidade e profissionalismo.'
      },
      benefit4: {
        title: 'Controle Total',
        description: 'Gerenciamos cada detalhe do primeiro contato até a conclusão da viagem.'
      }
    },
    cta: {
      title: 'Pronto para expandir internacionalmente e fechar mais negócios?',
      subtitle: 'Associe-se a nós e acesse mercados de viagem de alta demanda.',
      button1: 'Contate-nos',
      button2: 'Agendar Chamada'
    },
    contact: {
      overline: 'Contato',
      title: 'Inicie Sua Parceria',
      subtitle: 'Preencha o formulário. Resposta em 12 horas.',
      form: {
        name: 'Seu Nome',
        agency: 'Nome da Agência',
        country: 'País',
        email: 'Email',
        message: 'Mensagem',
        messagePlaceholder: 'Conte-nos sobre sua agência e que mercados você quer acessar...',
        submit: 'Enviar Solicitação',
        sending: 'Enviando...'
      },
      success: 'Solicitação recebida. Entraremos em contato em 12 horas.',
      error: 'Erro ao enviar. Por favor tente novamente.',
      phone: {
        europe: 'Europa',
        asia: 'Ásia'
      }
    },
    footer: {
      tagline: 'Operador B2B de Viagens Internacional',
      rights: 'Todos os direitos reservados.'
    },
    specialization: {
      overline: 'Nossas Especializações',
      title: 'Expertise em Destinos',
      subtitle: 'Conhecimento local aprofundado nos mercados-chave entre Europa e Ásia.',
      korea: {
        title: 'Coreia do Sul',
        description: 'K-beauty, clínicas de bem-estar, experiências culturais e turismo estético em Seul e além.'
      },
      japan: {
        title: 'Japão',
        description: 'Imersão cultural premium, gastronomia Michelin, ryokan tradicional e viagens de luxo personalizadas.'
      },
      spain: {
        title: 'Espanha',
        description: 'Gastronomia mediterrânea, rotas de vinho, arquitetura modernista e experiências de lifestyle premium.'
      }
    }
  },

  // ============== GERMAN ==============
  de: {
    nav: {
      whatWeDo: 'Was Wir Tun',
      experiences: 'Erlebnisse',
      services: 'Dienstleistungen',
      howItWorks: 'Prozess',
      whyUs: 'Warum Wir',
      contact: 'Kontakt'
    },
    hero: {
      overline: 'Internationaler B2B-Reiseoperator',
      trustedPartnersAsia: 'Wir gestalten und führen stark nachgefragte Reiseerlebnisse mit vertrauenswürdigen Partnern in Asien durch',
      trustedPartnersEurope: 'Wir gestalten und führen stark nachgefragte Reiseerlebnisse mit vertrauenswürdigen Partnern in Europa durch',
      subtitle: 'Wir verbinden nicht nur Agenturen. Wir schließen Geschäfte ab und liefern Ergebnisse.',
      cta1: 'Partnerschaft Anfragen',
      cta2: 'Zusammenarbeit Starten'
    },
    whatWeDo: {
      overline: 'Was Wir Tun',
      title: 'Mehr Als Verbindungen',
      subtitle: 'Wir sind keine traditionelle Reiseagentur. Wir sind ein internationaler B2B-Operator, der Reiseerlebnisse gestaltet, koordiniert und durchführt.',
      point1: {
        title: 'Erlebnisse Gestalten',
        description: 'Wir erstellen stark nachgefragte Reiseprogramme, die auf die Kunden Ihrer Agentur zugeschnitten sind.'
      },
      point2: {
        title: 'Partner Verbinden',
        description: 'Wir vermitteln Sie mit verifizierten lokalen Agenturen, die Ihren Standards entsprechen.'
      },
      point3: {
        title: 'Operationen Durchführen',
        description: 'Wir verwalten die komplette Koordination und Unterstützung vor Ort.'
      }
    },
    experiences: {
      overline: 'Erlebniskategorien',
      title: 'Spezialisierte Reiseprogramme',
      subtitle: 'Vier Vertikalen für hochwertige internationale Reisen.',
      korea: {
        title: 'Beauty & Transformation',
        location: 'Südkorea',
        description: 'K-Beauty-Programme, dermatologische Erlebnisse, persönliches Styling und Transformationsreisen.',
        tags: ['K-Beauty', 'Ästhetik', 'Transformation']
      },
      japan: {
        title: 'Premium Kultur & Gastronomie',
        location: 'Japan',
        description: 'High-End-Omakase-Erlebnisse, traditionelle Teezeremonien, Tempel und hochkuratierte Premium-Reisen.',
        tags: ['Omakase', 'Kultur', 'Premium']
      },
      china: {
        title: 'Business & Kultur',
        location: 'China',
        description: 'Geschäftsreisen, Messen, urbane Erlebnisse in Shanghai und Shenzhen, historische Routen.',
        tags: ['Business', 'Handel', 'Urban']
      },
      spain: {
        title: 'Lifestyle & Social Europe',
        location: 'Spanien',
        description: 'Gastronomie, Wein, mediterraner Lebensstil, soziale Erlebnisse, Premium-Events und lokale Immersion.',
        tags: ['Gastronomie', 'Lifestyle', 'Social']
      }
    },
    services: {
      overline: 'B2B-Dienstleistungen',
      title: 'Vollständiger Operativer Support',
      service1: {
        title: 'Partnersuche',
        description: 'Wir identifizieren und validieren die richtigen lokalen Agenturen für Ihre Bedürfnisse.'
      },
      service2: {
        title: 'Agenturvalidierung',
        description: 'Rigoroser Überprüfungsprozess zur Sicherstellung von Qualität und Zuverlässigkeit.'
      },
      service3: {
        title: 'B2B-Verhandlung',
        description: 'Wir kümmern uns um kommerzielle Bedingungen und Partnerschaftsvereinbarungen.'
      },
      service4: {
        title: 'Reisekoordination',
        description: 'Vollständiges Logistikmanagement von der Buchung bis zur Durchführung.'
      },
      service5: {
        title: 'Support vor Ort',
        description: 'Lokale Unterstützung während des gesamten Reiseerlebnisses.'
      }
    },
    howItWorks: {
      overline: 'Prozess',
      title: 'So Funktioniert\'s',
      step1: {
        title: 'Anfrage Einreichen',
        description: 'Die Agentur reicht Kundenanforderungen und Zielvorlieben ein.'
      },
      step2: {
        title: 'Design & Matching',
        description: 'Wir gestalten das Erlebnis und finden den idealen lokalen Partner.'
      },
      step3: {
        title: 'Ausführung & Lieferung',
        description: 'Wir koordinieren den Betrieb und führen die Reise von Anfang bis Ende durch.'
      }
    },
    whyUs: {
      overline: 'Warum Kaesthetic',
      title: 'Ergebnisse, Keine Versprechen',
      benefit1: {
        title: 'Asien–Europa Spezialisten',
        description: 'Ausschließlich auf hochwertige Reiseströme zwischen Kontinenten fokussiert.'
      },
      benefit2: {
        title: 'Schnelle Ausführung',
        description: 'Antwort in weniger als 12 Stunden. Wir bewegen uns in Geschäftsgeschwindigkeit.'
      },
      benefit3: {
        title: 'Verifiziertes Netzwerk',
        description: 'Jeder Partner ist auf Qualität, Zuverlässigkeit und Professionalität geprüft.'
      },
      benefit4: {
        title: 'End-to-End Kontrolle',
        description: 'Wir verwalten jedes Detail vom ersten Kontakt bis zum Reiseabschluss.'
      }
    },
    cta: {
      title: 'Bereit, international zu expandieren und mehr Geschäfte abzuschließen?',
      subtitle: 'Werden Sie unser Partner und erschließen Sie stark nachgefragte Reisemärkte.',
      button1: 'Kontaktieren Sie uns',
      button2: 'Anruf Vereinbaren'
    },
    contact: {
      overline: 'Kontakt',
      title: 'Starten Sie Ihre Partnerschaft',
      subtitle: 'Füllen Sie das Formular aus. Antwort innerhalb von 12 Stunden.',
      form: {
        name: 'Ihr Name',
        agency: 'Agenturname',
        country: 'Land',
        email: 'E-Mail',
        message: 'Nachricht',
        messagePlaceholder: 'Erzählen Sie uns von Ihrer Agentur und welche Märkte Sie erschließen möchten...',
        submit: 'Anfrage Senden',
        sending: 'Wird gesendet...'
      },
      success: 'Anfrage erhalten. Wir werden Sie innerhalb von 12 Stunden kontaktieren.',
      error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
      phone: {
        europe: 'Europa',
        asia: 'Asien'
      }
    },
    footer: {
      tagline: 'Internationaler B2B-Reiseoperator',
      rights: 'Alle Rechte vorbehalten.'
    },
    specialization: {
      overline: 'Unsere Spezialisierungen',
      title: 'Reiseziel-Expertise',
      subtitle: 'Tiefes lokales Wissen über Schlüsselmärkte zwischen Europa und Asien.',
      korea: {
        title: 'Südkorea',
        description: 'K-Beauty, Wellness-Kliniken, Kulturerlebnisse und Ästhetiktourismus in Seoul und darüber hinaus.'
      },
      japan: {
        title: 'Japan',
        description: 'Premium-Kulturimmersion, Michelin-Sterne-Gastronomie, traditionelle Ryokan und exklusiv kuratierte Luxusreisen.'
      },
      spain: {
        title: 'Spanien',
        description: 'Mediterrane Gastronomie, Weinrouten, modernistische Architektur und Premium-Lifestyle-Erlebnisse.'
      }
    }
  },

  // ============== ITALIAN ==============
  it: {
    nav: {
      whatWeDo: 'Cosa Facciamo',
      experiences: 'Esperienze',
      services: 'Servizi',
      howItWorks: 'Processo',
      whyUs: 'Perché Noi',
      contact: 'Contatto'
    },
    hero: {
      overline: 'Operatore B2B di Viaggio Internazionale',
      trustedPartnersAsia: 'Progettiamo ed eseguiamo esperienze di viaggio ad alta domanda con partner fidati in Asia',
      trustedPartnersEurope: 'Progettiamo ed eseguiamo esperienze di viaggio ad alta domanda con partner fidati in Europa',
      subtitle: 'Non colleghiamo solo agenzie. Chiudiamo accordi e consegniamo risultati.',
      cta1: 'Richiedi Partnership',
      cta2: 'Inizia Collaborazione'
    },
    whatWeDo: {
      overline: 'Cosa Facciamo',
      title: 'Oltre le Connessioni',
      subtitle: 'Non siamo un\'agenzia di viaggi tradizionale. Siamo un operatore B2B internazionale che progetta, coordina ed esegue esperienze di viaggio.',
      point1: {
        title: 'Progettiamo Esperienze',
        description: 'Creiamo programmi di viaggio ad alta domanda su misura per i clienti della tua agenzia.'
      },
      point2: {
        title: 'Connettiamo Partner',
        description: 'Ti mettiamo in contatto con agenzie locali verificate che soddisfano i tuoi standard.'
      },
      point3: {
        title: 'Eseguiamo Operazioni',
        description: 'Gestiamo il coordinamento completo e il supporto sul posto.'
      }
    },
    experiences: {
      overline: 'Categorie di Esperienza',
      title: 'Programmi di Viaggio Specializzati',
      subtitle: 'Quattro verticali progettate per viaggi internazionali di alto valore.',
      korea: {
        title: 'Bellezza e Trasformazione',
        location: 'Corea del Sud',
        description: 'Programmi K-beauty, esperienze dermatologiche, styling personale e viaggi di trasformazione.',
        tags: ['K-Beauty', 'Estetica', 'Trasformazione']
      },
      japan: {
        title: 'Cultura e Gastronomia Premium',
        location: 'Giappone',
        description: 'Esperienze omakase di alto livello, cerimonie del tè tradizionali, templi e viaggi premium molto curati.',
        tags: ['Omakase', 'Cultura', 'Premium']
      },
      china: {
        title: 'Business e Cultura',
        location: 'Cina',
        description: 'Viaggi d\'affari, fiere commerciali, esperienze urbane a Shanghai e Shenzhen, percorsi storici.',
        tags: ['Business', 'Commercio', 'Urbano']
      },
      spain: {
        title: 'Lifestyle e Social Europa',
        location: 'Spagna',
        description: 'Gastronomia, vino, stile di vita mediterraneo, esperienze sociali, eventi premium e immersione locale.',
        tags: ['Gastronomia', 'Lifestyle', 'Social']
      }
    },
    services: {
      overline: 'Servizi B2B',
      title: 'Supporto Operativo Completo',
      service1: {
        title: 'Ricerca Partner',
        description: 'Identifichiamo e validiamo le agenzie locali giuste per le tue esigenze.'
      },
      service2: {
        title: 'Validazione Agenzie',
        description: 'Processo di verifica rigoroso per garantire qualità e affidabilità.'
      },
      service3: {
        title: 'Negoziazione B2B',
        description: 'Gestiamo i termini commerciali e gli accordi di partnership.'
      },
      service4: {
        title: 'Coordinamento Viaggi',
        description: 'Gestione logistica completa dalla prenotazione all\'esecuzione.'
      },
      service5: {
        title: 'Supporto sul Posto',
        description: 'Assistenza locale durante tutta l\'esperienza di viaggio.'
      }
    },
    howItWorks: {
      overline: 'Processo',
      title: 'Come Funziona',
      step1: {
        title: 'Invia Richiesta',
        description: 'L\'agenzia invia i requisiti del cliente e le preferenze di destinazione.'
      },
      step2: {
        title: 'Design e Match',
        description: 'Progettiamo l\'esperienza e troviamo il partner locale ideale.'
      },
      step3: {
        title: 'Esecuzione e Consegna',
        description: 'Coordiniamo le operazioni ed eseguiamo il viaggio dall\'inizio alla fine.'
      }
    },
    whyUs: {
      overline: 'Perché Kaesthetic',
      title: 'Risultati, Non Promesse',
      benefit1: {
        title: 'Specialisti Asia–Europa',
        description: 'Focalizzati esclusivamente sui flussi di viaggio di alto valore tra continenti.'
      },
      benefit2: {
        title: 'Esecuzione Rapida',
        description: 'Risposta in meno di 12 ore. Ci muoviamo alla velocità del business.'
      },
      benefit3: {
        title: 'Rete Verificata',
        description: 'Ogni partner è validato per qualità, affidabilità e professionalità.'
      },
      benefit4: {
        title: 'Controllo Totale',
        description: 'Gestiamo ogni dettaglio dal primo contatto al completamento del viaggio.'
      }
    },
    cta: {
      title: 'Pronto ad espanderti internazionalmente e chiudere più affari?',
      subtitle: 'Diventa nostro partner e accedi ai mercati di viaggio ad alta domanda.',
      button1: 'Contattaci',
      button2: 'Prenota una Chiamata'
    },
    contact: {
      overline: 'Contatto',
      title: 'Inizia la Tua Partnership',
      subtitle: 'Compila il modulo. Risposta entro 12 ore.',
      form: {
        name: 'Il Tuo Nome',
        agency: 'Nome Agenzia',
        country: 'Paese',
        email: 'Email',
        message: 'Messaggio',
        messagePlaceholder: 'Parlaci della tua agenzia e dei mercati a cui vuoi accedere...',
        submit: 'Invia Richiesta',
        sending: 'Invio in corso...'
      },
      success: 'Richiesta ricevuta. Ti contatteremo entro 12 ore.',
      error: 'Errore nell\'invio. Per favore riprova.',
      phone: {
        europe: 'Europa',
        asia: 'Asia'
      }
    },
    footer: {
      tagline: 'Operatore B2B di Viaggio Internazionale',
      rights: 'Tutti i diritti riservati.'
    },
    specialization: {
      overline: 'Le Nostre Specializzazioni',
      title: 'Esperienza nelle Destinazioni',
      subtitle: 'Profonda conoscenza locale dei mercati chiave tra Europa e Asia.',
      korea: {
        title: 'Corea del Sud',
        description: 'K-beauty, cliniche di benessere, esperienze culturali e turismo estetico a Seoul e dintorni.'
      },
      japan: {
        title: 'Giappone',
        description: 'Immersione culturale premium, gastronomia stellata Michelin, ryokan tradizionale e viaggi di lusso.'
      },
      spain: {
        title: 'Spagna',
        description: 'Gastronomia mediterranea, percorsi enologici, architettura modernista ed esperienze lifestyle premium.'
      }
    }
  },

  // ============== GREEK ==============
  el: {
    nav: {
      whatWeDo: 'Τι Κάνουμε',
      experiences: 'Εμπειρίες',
      services: 'Υπηρεσίες',
      howItWorks: 'Διαδικασία',
      whyUs: 'Γιατί Εμάς',
      contact: 'Επικοινωνία'
    },
    hero: {
      overline: 'Διεθνής B2B Χειριστής Ταξιδιών',
      trustedPartnersAsia: 'Σχεδιάζουμε και εκτελούμε ταξιδιωτικές εμπειρίες υψηλής ζήτησης μέσω αξιόπιστων συνεργατών στην Ασία',
      trustedPartnersEurope: 'Σχεδιάζουμε και εκτελούμε ταξιδιωτικές εμπειρίες υψηλής ζήτησης μέσω αξιόπιστων συνεργατών στην Ευρώπη',
      subtitle: 'Δεν συνδέουμε απλά πρακτορεία. Κλείνουμε συμφωνίες και παραδίδουμε αποτελέσματα.',
      cta1: 'Αίτημα Συνεργασίας',
      cta2: 'Έναρξη Συνεργασίας'
    },
    whatWeDo: {
      overline: 'Τι Κάνουμε',
      title: 'Πέρα από τις Συνδέσεις',
      subtitle: 'Δεν είμαστε παραδοσιακό ταξιδιωτικό πρακτορείο. Είμαστε διεθνής B2B χειριστής που σχεδιάζει, συντονίζει και εκτελεί ταξιδιωτικές εμπειρίες.',
      point1: {
        title: 'Σχεδιάζουμε Εμπειρίες',
        description: 'Δημιουργούμε προγράμματα ταξιδιών υψηλής ζήτησης προσαρμοσμένα στους πελάτες του πρακτορείου σας.'
      },
      point2: {
        title: 'Συνδέουμε Συνεργάτες',
        description: 'Σας συνδέουμε με επαληθευμένα τοπικά πρακτορεία που πληρούν τα πρότυπά σας.'
      },
      point3: {
        title: 'Εκτελούμε Λειτουργίες',
        description: 'Διαχειριζόμαστε τον πλήρη συντονισμό και την υποστήριξη επιτόπου.'
      }
    },
    experiences: {
      overline: 'Κατηγορίες Εμπειριών',
      title: 'Εξειδικευμένα Ταξιδιωτικά Προγράμματα',
      subtitle: 'Τέσσερις κατηγορίες σχεδιασμένες για διεθνή ταξίδια υψηλής αξίας.',
      korea: {
        title: 'Ομορφιά & Μεταμόρφωση',
        location: 'Νότια Κορέα',
        description: 'Προγράμματα K-beauty, δερματολογικές εμπειρίες, προσωπικό styling και ταξίδια μεταμόρφωσης.',
        tags: ['K-Beauty', 'Αισθητική', 'Μεταμόρφωση']
      },
      japan: {
        title: 'Premium Πολιτισμός & Γαστρονομία',
        location: 'Ιαπωνία',
        description: 'Υψηλού επιπέδου εμπειρίες omakase, παραδοσιακές τελετές τσαγιού, ναοί και premium ταξίδια.',
        tags: ['Omakase', 'Πολιτισμός', 'Premium']
      },
      china: {
        title: 'Επιχειρήσεις & Πολιτισμός',
        location: 'Κίνα',
        description: 'Επαγγελματικά ταξίδια, εκθέσεις, αστικές εμπειρίες σε Σαγκάη και Σενζέν, ιστορικές διαδρομές.',
        tags: ['Business', 'Εμπόριο', 'Αστικό']
      },
      spain: {
        title: 'Lifestyle & Social Ευρώπη',
        location: 'Ισπανία',
        description: 'Γαστρονομία, κρασί, μεσογειακός τρόπος ζωής, κοινωνικές εμπειρίες, premium εκδηλώσεις.',
        tags: ['Γαστρονομία', 'Lifestyle', 'Social']
      }
    },
    services: {
      overline: 'Υπηρεσίες B2B',
      title: 'Πλήρης Λειτουργική Υποστήριξη',
      service1: {
        title: 'Αναζήτηση Συνεργατών',
        description: 'Εντοπίζουμε και επαληθεύουμε τα σωστά τοπικά πρακτορεία για τις ανάγκες σας.'
      },
      service2: {
        title: 'Επαλήθευση Πρακτορείων',
        description: 'Αυστηρή διαδικασία ελέγχου για διασφάλιση ποιότητας και αξιοπιστίας.'
      },
      service3: {
        title: 'Διαπραγμάτευση B2B',
        description: 'Χειριζόμαστε εμπορικούς όρους και συμφωνίες συνεργασίας.'
      },
      service4: {
        title: 'Συντονισμός Ταξιδιών',
        description: 'Πλήρης διαχείριση logistics από την κράτηση έως την εκτέλεση.'
      },
      service5: {
        title: 'Υποστήριξη Επιτόπου',
        description: 'Τοπική βοήθεια καθ\' όλη τη διάρκεια της ταξιδιωτικής εμπειρίας.'
      }
    },
    howItWorks: {
      overline: 'Διαδικασία',
      title: 'Πώς Λειτουργεί',
      step1: {
        title: 'Υποβολή Αιτήματος',
        description: 'Το πρακτορείο υποβάλλει απαιτήσεις πελάτη και προτιμήσεις προορισμού.'
      },
      step2: {
        title: 'Σχεδιασμός & Matching',
        description: 'Σχεδιάζουμε την εμπειρία και βρίσκουμε τον ιδανικό τοπικό συνεργάτη.'
      },
      step3: {
        title: 'Εκτέλεση & Παράδοση',
        description: 'Συντονίζουμε τις λειτουργίες και εκτελούμε το ταξίδι από την αρχή έως το τέλος.'
      }
    },
    whyUs: {
      overline: 'Γιατί Kaesthetic',
      title: 'Αποτελέσματα, Όχι Υποσχέσεις',
      benefit1: {
        title: 'Ειδικοί Ασία–Ευρώπη',
        description: 'Εστιασμένοι αποκλειστικά σε ροές ταξιδιών υψηλής αξίας μεταξύ ηπείρων.'
      },
      benefit2: {
        title: 'Γρήγορη Εκτέλεση',
        description: 'Απάντηση σε λιγότερο από 12 ώρες. Κινούμαστε με ταχύτητα επιχειρήσεων.'
      },
      benefit3: {
        title: 'Επαληθευμένο Δίκτυο',
        description: 'Κάθε συνεργάτης είναι ελεγμένος για ποιότητα, αξιοπιστία και επαγγελματισμό.'
      },
      benefit4: {
        title: 'Πλήρης Έλεγχος',
        description: 'Διαχειριζόμαστε κάθε λεπτομέρεια από την πρώτη επαφή έως την ολοκλήρωση.'
      }
    },
    cta: {
      title: 'Έτοιμοι να επεκταθείτε διεθνώς και να κλείσετε περισσότερες συμφωνίες;',
      subtitle: 'Γίνετε συνεργάτης μας και αποκτήστε πρόσβαση σε αγορές ταξιδιών υψηλής ζήτησης.',
      button1: 'Επικοινωνήστε',
      button2: 'Προγραμματίστε Κλήση'
    },
    contact: {
      overline: 'Επικοινωνία',
      title: 'Ξεκινήστε τη Συνεργασία σας',
      subtitle: 'Συμπληρώστε τη φόρμα. Απάντηση εντός 12 ωρών.',
      form: {
        name: 'Το Όνομά σας',
        agency: 'Όνομα Πρακτορείου',
        country: 'Χώρα',
        email: 'Email',
        message: 'Μήνυμα',
        messagePlaceholder: 'Πείτε μας για το πρακτορείο σας και ποιες αγορές θέλετε να προσεγγίσετε...',
        submit: 'Υποβολή Αιτήματος',
        sending: 'Αποστολή...'
      },
      success: 'Αίτημα παραλήφθηκε. Θα επικοινωνήσουμε εντός 12 ωρών.',
      error: 'Σφάλμα αποστολής. Παρακαλώ προσπαθήστε ξανά.',
      phone: {
        europe: 'Ευρώπη',
        asia: 'Ασία'
      }
    },
    footer: {
      tagline: 'Διεθνής B2B Χειριστής Ταξιδιών',
      rights: 'Με επιφύλαξη παντός δικαιώματος.'
    },
    specialization: {
      overline: 'Οι Εξειδικεύσεις μας',
      title: 'Εξειδίκευση Προορισμών',
      subtitle: 'Βαθιά τοπική γνώση στις βασικές αγορές μεταξύ Ευρώπης και Ασίας.',
      korea: {
        title: 'Νότια Κορέα',
        description: 'K-beauty, κλινικές ευεξίας, πολιτιστικές εμπειρίες και αισθητικός τουρισμός στη Σεούλ.'
      },
      japan: {
        title: 'Ιαπωνία',
        description: 'Υψηλή πολιτιστική εμβάπτιση, γαστρονομία Michelin, παραδοσιακό ryokan και πολυτελή ταξίδια.'
      },
      spain: {
        title: 'Ισπανία',
        description: 'Μεσογειακή γαστρονομία, οινοποιητικές διαδρομές, μοντερνιστική αρχιτεκτονική και premium lifestyle.'
      }
    }
  },

  // ============== RUSSIAN ==============
  ru: {
    nav: {
      whatWeDo: 'Что Мы Делаем',
      experiences: 'Опыт',
      services: 'Услуги',
      howItWorks: 'Процесс',
      whyUs: 'Почему Мы',
      contact: 'Контакт'
    },
    hero: {
      overline: 'Международный B2B Туроператор',
      trustedPartnersAsia: 'Мы разрабатываем и реализуем востребованные туристические программы через надежных партнеров в Азии',
      trustedPartnersEurope: 'Мы разрабатываем и реализуем востребованные туристические программы через надежных партнеров в Европе',
      subtitle: 'Мы не просто соединяем агентства. Мы заключаем сделки и доставляем результаты.',
      cta1: 'Запросить Партнерство',
      cta2: 'Начать Сотрудничество'
    },
    whatWeDo: {
      overline: 'Что Мы Делаем',
      title: 'Больше Чем Связи',
      subtitle: 'Мы не традиционное туристическое агентство. Мы международный B2B оператор, который разрабатывает, координирует и реализует туристические программы.',
      point1: {
        title: 'Разрабатываем Программы',
        description: 'Создаем востребованные туристические программы, адаптированные для клиентов вашего агентства.'
      },
      point2: {
        title: 'Соединяем Партнеров',
        description: 'Подбираем проверенные местные агентства, соответствующие вашим стандартам.'
      },
      point3: {
        title: 'Выполняем Операции',
        description: 'Управляем полной координацией и поддержкой на месте.'
      }
    },
    experiences: {
      overline: 'Категории Опыта',
      title: 'Специализированные Туристические Программы',
      subtitle: 'Четыре направления для высокоценных международных путешествий.',
      korea: {
        title: 'Красота и Трансформация',
        location: 'Южная Корея',
        description: 'K-beauty программы, дерматологический опыт, персональный стайлинг и путешествия трансформации.',
        tags: ['K-Beauty', 'Эстетика', 'Трансформация']
      },
      japan: {
        title: 'Премиум Культура и Гастрономия',
        location: 'Япония',
        description: 'Высококлассный опыт омакасе, традиционные чайные церемонии, храмы и премиум-путешествия.',
        tags: ['Омакасе', 'Культура', 'Премиум']
      },
      china: {
        title: 'Бизнес и Культура',
        location: 'Китай',
        description: 'Деловые поездки, торговые выставки, городской опыт в Шанхае и Шэньчжэне, исторические маршруты.',
        tags: ['Бизнес', 'Торговля', 'Городской']
      },
      spain: {
        title: 'Лайфстайл и Социальная Европа',
        location: 'Испания',
        description: 'Гастрономия, вино, средиземноморский образ жизни, социальный опыт, премиум-мероприятия.',
        tags: ['Гастрономия', 'Лайфстайл', 'Социальный']
      }
    },
    services: {
      overline: 'B2B Услуги',
      title: 'Полная Операционная Поддержка',
      service1: {
        title: 'Поиск Партнеров',
        description: 'Находим и проверяем подходящие местные агентства для ваших потребностей.'
      },
      service2: {
        title: 'Проверка Агентств',
        description: 'Строгий процесс проверки для обеспечения качества и надежности.'
      },
      service3: {
        title: 'B2B Переговоры',
        description: 'Ведем коммерческие переговоры и заключаем партнерские соглашения.'
      },
      service4: {
        title: 'Координация Поездок',
        description: 'Полное логистическое управление от бронирования до исполнения.'
      },
      service5: {
        title: 'Поддержка на Месте',
        description: 'Местная помощь на протяжении всего путешествия.'
      }
    },
    howItWorks: {
      overline: 'Процесс',
      title: 'Как Это Работает',
      step1: {
        title: 'Отправьте Запрос',
        description: 'Агентство отправляет требования клиента и предпочтения по направлению.'
      },
      step2: {
        title: 'Дизайн и Подбор',
        description: 'Разрабатываем программу и находим идеального местного партнера.'
      },
      step3: {
        title: 'Выполнение и Доставка',
        description: 'Координируем операции и выполняем поездку от начала до конца.'
      }
    },
    whyUs: {
      overline: 'Почему Kaesthetic',
      title: 'Результаты, Не Обещания',
      benefit1: {
        title: 'Специалисты Азия–Европа',
        description: 'Сфокусированы исключительно на высокоценных туристических потоках между континентами.'
      },
      benefit2: {
        title: 'Быстрое Исполнение',
        description: 'Ответ менее чем за 12 часов. Работаем со скоростью бизнеса.'
      },
      benefit3: {
        title: 'Проверенная Сеть',
        description: 'Каждый партнер проверен на качество, надежность и профессионализм.'
      },
      benefit4: {
        title: 'Полный Контроль',
        description: 'Управляем каждой деталью от первого контакта до завершения поездки.'
      }
    },
    cta: {
      title: 'Готовы выйти на международный рынок и заключать больше сделок?',
      subtitle: 'Станьте нашим партнером и получите доступ к востребованным туристическим рынкам.',
      button1: 'Связаться',
      button2: 'Запланировать Звонок'
    },
    contact: {
      overline: 'Контакт',
      title: 'Начните Партнерство',
      subtitle: 'Заполните форму. Ответ в течение 12 часов.',
      form: {
        name: 'Ваше Имя',
        agency: 'Название Агентства',
        country: 'Страна',
        email: 'Email',
        message: 'Сообщение',
        messagePlaceholder: 'Расскажите о вашем агентстве и какие рынки хотите освоить...',
        submit: 'Отправить Запрос',
        sending: 'Отправка...'
      },
      success: 'Запрос получен. Свяжемся в течение 12 часов.',
      error: 'Ошибка отправки. Пожалуйста, попробуйте снова.',
      phone: {
        europe: 'Европа',
        asia: 'Азия'
      }
    },
    footer: {
      tagline: 'Международный B2B Туроператор',
      rights: 'Все права защищены.'
    },
    specialization: {
      overline: 'Наши Специализации',
      title: 'Экспертиза Направлений',
      subtitle: 'Глубокое знание ключевых рынков между Европой и Азией.',
      korea: {
        title: 'Южная Корея',
        description: 'К-красота, велнес-клиники, культурный туризм и эстетические путешествия в Сеуле и не только.'
      },
      japan: {
        title: 'Япония',
        description: 'Премиум культурное погружение, гастрономия со звёздами Мишлен, традиционные рёканы и люкс-туры.'
      },
      spain: {
        title: 'Испания',
        description: 'Средиземноморская гастрономия, винные маршруты, архитектура модернизма и премиум лайфстайл.'
      }
    }
  }
};

export default translations;
